export const SET_NEW_ORDERS = 'SET_NEW_ORDERS';
export const SET_NEW_MESSAGES = 'SET_NEW_MESSAGES';
export const SET_INTERGLOBO_COMMENTS = 'SET_INTERGLOBO_COMMENTS';
export const SET_CUSTOMER_COMMENTS = 'SET_CUSTOMER_COMMENTS';
export const SET_ORDERS_AND_ATTENTION = 'SET_ORDERS_AND_ATTENTION';